import { memo, useEffect, useRef } from 'react';
import { CollectionPointWithI18nKey } from '../../../../types/collectionPoints';
import { config, getAssetUrl } from '../../../../utils/config';
import './style.scss';

const DEFAULT_INITIAL_CENTER_COORDINATES = { latitude: 53.5483197, longitude: 10.0006301 };

type LocationsMapProps = {
  locations?: CollectionPointWithI18nKey[];
  onMarkerClick: (id: string) => void;
};

const Map = ({ locations, onMarkerClick }: LocationsMapProps) => {
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<google.maps.Map>();

  useEffect(() => {
    const { latitude, longitude } =
      config.availableCountries.shipping[0].centerCoordinates ?? DEFAULT_INITIAL_CENTER_COORDINATES;
    mapRef.current = new google.maps.Map(mapContainerRef.current!, {
      disableDefaultUI: true,
      zoomControl: true,
      zoom: 5,
      center: { lat: latitude, lng: longitude },
    });
  }, []);

  useEffect(() => {
    if (!locations?.length) {
      return;
    }
    const markers = locations.map(location => {
      const { latitude, longitude } = location.displayData.coordinates;
      const { collectionPointId } = location.specification;
      const marker = new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: mapRef.current!,
        icon: {
          scaledSize: new google.maps.Size(50, 50),
          url: getAssetUrl(`collectionPoints/mapPins/${location.i18nKey}.svg`),
        },
      });
      marker.addListener('click', () => onMarkerClick?.(collectionPointId));
      return marker;
    });
    const bounds = new google.maps.LatLngBounds();
    locations.slice(0, 7).forEach(location => {
      const { latitude, longitude } = location.displayData.coordinates;
      bounds.extend({ lat: latitude, lng: longitude });
    });
    mapRef.current!.fitBounds(bounds);
    // eslint-disable-next-line consistent-return
    return () => {
      // Remove old markers
      markers.forEach(marker => marker.setMap(null));
    };
  }, [locations]);

  return <div className="collection-point-search-page__map" ref={mapContainerRef}></div>;
};

export default memo(Map);
